/*
PROV: COHINT037.BF.UIUTILS01
REQ: SYS-ARCH-15
WHY: Shared className utility (clsx + tailwind-merge) used by all components.
*/

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
